
import { GoogleGenAI, Type } from "@google/genai";
import { UserProfile, MatchResult } from "../types";

export async function findMatches(
  currentUser: UserProfile,
  potentialMatches: UserProfile[]
): Promise<MatchResult[]> {
  // Инициализация строго по правилам SDK
  const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });

  const SYSTEM_INSTRUCTION = `
Ты — AI-движок для Random Coffee Vietnam. 
Твоя задача: анализировать профили пользователей и подбирать идеальных партнеров для нетворкинга.
Учитывай сферу деятельности, город и цели. 
Формат вывода: только JSON. Никакого лишнего текста.
`;

  const prompt = `
Пользователь:
${JSON.stringify({
  name: currentUser.name,
  activity: currentUser.activitySphere,
  goal: currentUser.goal,
  lookingFor: currentUser.lookingFor,
  canHelpWith: currentUser.canHelpWith
})}

Список кандидатов:
${JSON.stringify(potentialMatches.map(u => ({
  id: u.id,
  name: u.name,
  activity: u.activitySphere,
  goal: u.goal,
  about: u.aboutMe
})))}

Подбери до 3 наиболее подходящих мэтчей.
`;

  try {
    const response = await ai.models.generateContent({
      model: "gemini-3-flash-preview",
      contents: prompt,
      config: {
        systemInstruction: SYSTEM_INSTRUCTION,
        responseMimeType: "application/json",
        responseSchema: {
          type: Type.OBJECT,
          properties: {
            matches: {
              type: Type.ARRAY,
              items: {
                type: Type.OBJECT,
                properties: {
                  userId: { type: Type.STRING },
                  reasoning: { type: Type.STRING, description: "Почему эти люди подходят друг другу на русском языке" },
                  suggestedFormat: { type: Type.STRING, description: "Рекомендация: кофе в Нячанге, онлайн-звонок и т.д." }
                },
                required: ["userId", "reasoning", "suggestedFormat"]
              }
            }
          },
          required: ["matches"]
        }
      }
    });

    const jsonStr = response.text;
    if (!jsonStr) return [];
    
    const parsed = JSON.parse(jsonStr);
    return parsed.matches || [];
  } catch (error) {
    console.error("AI Matchmaking Error:", error);
    return [];
  }
}
